import { Model, type ModelProps } from '@/infra/model'
import { observable } from 'mobx'
import { Id } from '@/infra/id'
import { unixEpoch } from '@/utils/date-util'

export type MessageBankReplyProps = ModelProps<MessageBankReply>

/**
 * A canned reply in a message bank.
 */
export class MessageBankReply extends Model<MessageBankReply> {
  id = Id.none

  @observable accessor title = ''
  @observable accessor content = ''
  @observable accessor authorId = Id.none
  @observable accessor authorPublicId = Id.none
  @observable accessor dateCreated = unixEpoch()
  @observable accessor dateModified = unixEpoch()
}
